import { startOfWeek } from 'date-fns';
import type { DateRange } from 'react-day-picker';
import { Calendar } from '@/components/ui/calendar';
import { PurchasePlanningCalendarDayButton } from '@/features/purchase-planning/purchase-planning-calendar-day-button';
import { cn } from '@/lib/utils';

type PurchasePlanningCalendarProps = {
  dateRange: DateRange | undefined;
  handleSelect: (dateRange: DateRange | undefined) => void;
};

export function PurchasePlanningCalendar({
  dateRange,
  handleSelect,
}: PurchasePlanningCalendarProps) {
  const nextWeekStart = startOfWeek(new Date(), {
    weekStartsOn: 1,
  });

  return (
    <div className='mb-6'>
      <Calendar
        className='w-full rounded-lg border shadow-sm [--cell-size:--spacing(10)]'
        classNames={{
          root: 'w-full',
          week_number: 'mt-1 font-bold text-primary',
          week: cn(
            'group/week mt-2 flex w-full',
            'has-[:hover]:[&>*:nth-child(2)_button]:rounded-r-none has-[:hover]:[&>*:nth-child(2)_button]:rounded-l-md',
            'has-[:hover]:[&>*:last-child_button]:rounded-r-md has-[:hover]:[&>*:last-child_button]:rounded-l-none',
            'has-[:hover]:[&>*:not(:nth-child(2)):not(:last-child)_button]:rounded-none',
            'has-[:hover]:[&>*_button]:bg-accent',
            'has-[:hover]:[&>*_button]:text-accent-foreground',
            'has-[[data-range-start=true],[data-range-end=true]]:[&>*:nth-child(2)_button]:rounded-r-none has-[[data-range-start=true],[data-range-end=true]]:[&>*:nth-child(2)_button]:rounded-l-md',
            'has-[[data-range-start=true],[data-range-end=true]]:[&>*:last-child_button]:rounded-r-md has-[[data-range-start=true],[data-range-end=true]]:[&>*:last-child_button]:rounded-l-none',
            'has-[[data-range-start=true],[data-range-end=true]]:[&>*:not(:nth-child(2)):not(:last-child)_button]:rounded-none',
            'has-[[data-range-start=true],[data-range-end=true]]:[&>*_button]:bg-primary',
            'has-[[data-range-start=true],[data-range-end=true]]:[&>*_button]:text-primary-foreground',
          ),
          months: 'flex w-full gap-8',
          month: 'flex-1',
          month_caption: 'flex items-center justify-center',
          month_grid: 'w-full',
        }}
        components={{
          DayButton: PurchasePlanningCalendarDayButton,
        }}
        disabled={{ before: nextWeekStart }}
        mode='range'
        numberOfMonths={3}
        onSelect={handleSelect}
        selected={dateRange}
        showWeekNumber
        weekStartsOn={1}
      />
    </div>
  );
}
